<!--
 * @Descripttion: 
 * @version: 
 * @Author: 崔中超
 * @Date: 2023-03-03 09:28:10
 * @LastEditors: Andy
 * @LastEditTime: 2023-12-07 15:15:33
-->
<!--
/**
* @name: Home.vue
* @description: 首页
* @author: wenyongjiang
* @create: 2020/07/22 10:57:43
* @update: 2020/07/22 10:57:43
*/
-->
<template>
  <div :class="css.home">
    <span style="letter-spacing: 0.2em;">Welcome!</span>
    <k-popup :show.sync="isShowResetPopup" title="密码过期提示" layout="header,body,close,mask">
      <y-popup-body size="mini">
        <div class="mb-2" v-if="expiringDate >= 1" style="font-size:12px;color:red;padding:40px 0">
          您的密码将在{{ expiringDate }}天后过期，请及时更改!
        </div>
        <div class="mb-2" v-if="expiringDate <= 0" style="font-size:12px;color:red;padding:40px 0">您的密码即将过期，请及时更改！</div>
      </y-popup-body>
    </k-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checking: false,
      expiringDate: null,
      isShowResetPopup: false
    };
  },
  methods: {
    async checkLogin() {
      try {
        const login = await this.$lf.getItem('login');
        if (!login) {
          return this.$router.replace({ name: 'login' });
        }
        this.expiringDate = login.daysExpiredOfPwd;
        if ((this.expiringDate != 'null' && this.expiringDate) || this.expiringDate === 0) {
          this.isShowResetPopup = true;
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  created() {
    this.checkLogin();
    // this.$controller.open(
    //   {
    //     name: '',
    //     query: {
    //       refresh: new Date() - 0
    //     }
    //   },
    //   this.$router.currentRoute.name
    // );
  }
};
</script>

<style module="css" lang="postcss">
.home {
  height: calc(100vh - var(--top-height));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 55px;

  color: #ccc;
}
</style>
